import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import {} from '../../theme';

import { Button } from '../../ui';
import { Filter } from './filter';

const ClearButton = styled(Button)`
  margin-right: 16px;
`;

const FilterList = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;

const mapState = ({ filters, filtersSelected }) => ({
  filters,
  filtersSelected,
});

export const Filters = () => {
  const { filters, filtersSelected } = useSelector(mapState);
  const dispatch = useDispatch();

  const clear = () => {
    dispatch({ type: 'DRAW_DISABLED' });
    dispatch({ type: 'CLEAR_DRAW_AREA' });
    dispatch({ type: 'CLEAR_FILTERS' });
  };

  const onChange = (value, key, operator) => {
    dispatch({
      type: 'TRACK',
      payload: {
        name: 'Filter Selected',
        value,
        key,
        operator,
      },
    });
    dispatch({
      type: 'SELECT_FILTER',
      payload: {
        filter: {
          operator,
          key,
          value,
        },
      },
    });
  };

  return (
    <FilterList>
      {filters.map(({
        key, label, options, type, min, max, unit,
      }) => (
        <Filter
          filtersSelected={filtersSelected}
          key={key}
          onChange={onChange}
          filterKey={key}
          label={label}
          options={options}
          type={type}
          min={min}
          max={max}
          unit={unit}
        />
      ))}
      <ClearButton
        active={Object.keys(filtersSelected).length > 0}
        onClick={clear}
      >
        Clear Filters
      </ClearButton>
    </FilterList>
  );
};
